export class DeleteInspectionReqDto {
    inspectionIds: bigint[];
}
